<script lang="ts">
    import { link } from 'svelte-spa-router'

    import type DataProvider from '../services/data.provider'
    import type ServiceProvider from '../services/service.provider'

    export let dataProvider: DataProvider
    export let serviceProvider: ServiceProvider

    $: activity = serviceProvider.activityService.getActivityById(dataProvider.activityId)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-member-access
    $: group = activity ? serviceProvider.groupService.getGroupById(activity.skupina) : null

    export let activitySection = false
    export let dateTimeSection = false
    export let contactSection = false
</script>
<nav class="bno-container bno-section-menu">
    <div class="bno-container__content">
        <ul class="bno-section-menu__items">
            <li class="bno-section-menu__item" class:bno-section-menu__item--active={activitySection}>
                <span aria-hidden="true"></span>
                {#if dateTimeSection || contactSection}
                    {#if group}
                        <a href="/skupina/{group.id}" class="bno-link" use:link>
                            Předmět návštěvy
                        </a>
                    {:else}
                        <a href="/" class="bno-link" use:link>
                            Předmět návštěvy
                        </a>
                    {/if}
                {:else}
                    <span>Předmět návštěvy</span>
                {/if}
            </li>
            <li class="bno-section-menu__item" class:bno-section-menu__item--active={dateTimeSection}>
                <span aria-hidden="true"></span>
                {#if contactSection && activity}
                    <a href="/sluzba/{activity.id}" class="bno-link" use:link>
                        Termín
                    </a>
                {:else}
                    <span>Termín</span>
                {/if}
            </li>
            <li class="bno-section-menu__item" class:bno-section-menu__item--active={contactSection}>
                <span aria-hidden="true"></span>
                <span>Osobní informace</span>
            </li>
        </ul>
    </div>
</nav>
